import { List } from "immutable";
import { createAction } from "redux-actions";
import * as AlertActions from "../../actions/NotificationActions";
import { Thunk } from "../../actions/Thunk";
import * as M from "../../models";
import { Api } from "../../services/Api";

const prefix = "ADMIN_TAG_";

export class Constants {
    public static UPDATED_TAGS = prefix + "UPDATED_TAGS";
    public static LOADING_TAGS = prefix + "LOADING_TAGS";
}

export const loadTags = (toggleLoading?: boolean): Thunk => async (dispatch, getState) => {
    if (toggleLoading !== undefined)
        await dispatch(toggleLoadingTags(toggleLoading));

    const api = new Api(getState());
    const result = await api.get(Api.endpoints.admin.tag.list);

    if (result.isSuccess && result.data) {
        await dispatch(onTagsUpdated(List(result.data)));
    }
    else {
        await dispatch(AlertActions.notifyError(M.Result.Result.errorsOrMessage(result).join("<br />")));
    }

    return dispatch(toggleLoadingTags(false));
};

export const removeTag = (id: number): Thunk => async (dispatch, getState) => {
    let list = getState().adminTag.tags.data;
    const idx = list.findIndex((x) => x !== undefined && x.id === id);
    if (idx > -1) {
        list = list.remove(idx);
        return await dispatch(onTagsUpdated(list));
    }
    return;
};

export const updateTag = (item: M.Tag.TagAdmin): Thunk => async (dispatch, getState) => {
    return await dispatch(updateTags([item]));
};

export const updateTags = (updatedList: M.Tag.TagAdmin[]): Thunk => async (dispatch, getState) => {
    let list = getState().adminTag.tags.data;
    updatedList.map((item: M.Tag.TagAdmin) => {
        const idx = list.findIndex((x: M.Tag.TagAdmin) => x.id === item.id);
        list = idx > -1
            ? list.set(idx, item)
            : list.push(item);
    });

    return await dispatch(onTagsUpdated(list));
};

export const onTagsUpdated = createAction<List<M.Tag.TagAdmin>, List<M.Tag.TagAdmin>>(
    Constants.UPDATED_TAGS, (data) => (data),
);

export const toggleLoadingTags = createAction<boolean, boolean>(
    Constants.LOADING_TAGS, (loading) => (loading),
);



// WEBPACK FOOTER //
// ./src/store/adminTag/AdminTagActions.ts